import Loadable from '@/common/lazy/Loadable';
import imports from '@/routing/imports';

export default Loadable({ loader: imports.notifications, exp: Exp => Exp.NotificationsPage });
